import { adoptGlobal, decodeLayout, hasGlobal, layoutKey, type SphereConfig } from "@dyson/shared";

const pending = new Map<string, Promise<void>>();

/**
 * Fetch the sphere's layout from the server and adopt it (see shared
 * layout.ts), so this page doesn't make it itself: making it is the slow part
 * of loading a world, reading it a few milliseconds. Cached for good under its
 * key, so it's usually from the browser's or the edge's cache. If it can't be
 * had, nothing's lost: it's made here when it's first needed.
 */
export function loadLayout(base: string, sphere: SphereConfig): Promise<void> {
  if (hasGlobal(sphere)) return Promise.resolve();
  const key = layoutKey(sphere);
  let p = pending.get(key);
  if (!p) {
    p = fetch(`${base}/api/layout/${key}`)
      .then(async (res) => {
        if (!res.ok) throw new Error(`the server said ${res.status}`);
        const text = await res.text();
        if (!hasGlobal(sphere)) adoptGlobal(sphere, decodeLayout(sphere, text));
      })
      .catch((err) => console.warn("[layout] making it here instead:", (err as Error)?.message ?? err))
      .finally(() => pending.delete(key));
    pending.set(key, p);
  }
  return p;
}
